const toggle = () => {
    const button = document.querySelector('.pg-history__button');
    const lists = document.querySelector('.pg-history__lists');

    if (!button || !lists) return;

    button.addEventListener('click', () => {
        const isOpen = lists.hasAttribute('data-open');

        if (!isOpen) {
            lists.style.maxHeight = lists.scrollHeight + 'px';
            lists.setAttribute('data-open', '');
            button.setAttribute('data-open', '');
        } else {
            lists.style.maxHeight = '';
            lists.removeAttribute('data-open');
            button.removeAttribute('data-open');
        }
    });
};

const main = () => {
    if (document.querySelector('#page-company') == null) return;
    toggle();
};

export default main;
